import React from 'react';
import { IconButton as ChakraIconButton, IconButtonProps as ChakraIconButtonProps } from '@chakra-ui/react';

export function IconButton(props: ChakraIconButtonProps) {
  return <ChakraIconButton {...props} />;
}
